const MAX_ENTRIES = 50;
const cache = new Map<string, string>();

function normalise(url: string): string {
	return url.replace(/[?&]_cb=[^&]*/g, '').replace(/[?&]$/, '');
}

export function setIOSHighQualityUrl(
	masterUrl: string,
	variantUrl: string
): void {
	const key = normalise(masterUrl);
	if (!cache.has(key) && cache.size >= MAX_ENTRIES) {
		const firstKey = cache.keys().next().value;
		if (firstKey) cache.delete(firstKey);
	}
	cache.set(key, variantUrl);
}

export function getIOSHighQualityUrl(masterUrl: string): string | null {
	return cache.get(normalise(masterUrl)) ?? null;
}

function deleteIOSHighQualityUrl(masterUrl: string): void {
	cache.delete(normalise(masterUrl));
}

export function clearIOSQualityCache(): void {
	cache.clear();
}
